<se-text-editor class="se-text-editor"
                name="se-text-editor"
                tabindex="1"
                [class.isInError]="isInError"
                [class.disabled]="isDisabled"
                [(ngModel)]="value"
                [disabled]="isDisabled"
                [visible]="visible"
                [customCommandConfiguration]="customCommandConfiguration"
                [suggestionList]="suggestionList"
                [menuConfig]="predefinedMenuConfiguration"
                [title]="title"
                [language]="language"
                [defaultFontFamily]="defaultFontFamily"
                [defaultFontSize]="defaultFontSize"
                [defaultTextAlign]="defaultTextAlign"
                [defaultFontWeight]="defaultFontWeight"
                [defaultFontStyle]="defaultFontStyle"
                [defaultTextDecoration]="defaultTextDecoration"
                [expandSuggestionButton]="expandSuggestionButton"
                [shortcutList]="shortcutList"
                [visibilityButtonEnabled]="visibilityButtonEnabled"
                [defaultTextName]="defaultTextName"
                [lightLayout]="lightLayout"
                [isFromSpeechModal]="isFromSpeechModal"
                (requestSuggestions)="onTextEditorRequestSuggestion()"
                (textsSuggestions)="onTextSuggestion()"
                (contentChange)="onTextEditorContentChange($event, autoCompleteEnabled)"
                (shortcutDetected)="onTextEditorShortcut($event)"
                (commandRequested)="onTextEditorCommandRequested($event)"
                (keydown)="onKeyDown($event)"
                (visibilityNotify)="onVisibilityChange($event)"
                (isEmpty)="onIsEmptyChange($event)"
                (selectionChange)="onSelectionChange($event)"
                (emptySuggestions)="onAddNewInEmptySuggestions($event)"
                (startSpeechReconition)="onStartSpeechReconition($event)">
    <ng-content extra-buttons-before select="[extra-buttons-before]"></ng-content>
</se-text-editor>
